import { render, staticRenderFns } from "./ElVeikiantisPagal.vue?vue&type=template&id=7b7cc87e&scoped=true&"
import script from "./ElVeikiantisPagal.vue?vue&type=script&lang=js&"
export * from "./ElVeikiantisPagal.vue?vue&type=script&lang=js&"
import style0 from "./ElVeikiantisPagal.vue?vue&type=style&index=0&id=7b7cc87e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7cc87e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VRow})
